import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Intro from "./components/Intro";
import RiskTypes from "./components/RiskTypes";
import RedFlags from "./components/RedFlags";
import Guide from "./components/Guide";
import Checklist from "./components/Checklist";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Intro />
        <RiskTypes />
        <RedFlags />
        <Guide />
        <Checklist />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}